
export default {
  props: {
    classProp: {
      type: String,
      default: "white mt-10 pa-6"
    },
    sizeProp: {
      type: String,
      default: "12px"
    },
    colorProp: {
      type: String,
      default: "#858585"
    }
  }
};
